import { Children, Component, type ReactElement, type ReactNode } from 'react'

class DynamicFilters extends Component<ComponentProps, ComponentState> {
  state = this.getInitialState()

  getInitialState() {
    const { order = [] } = this.props
    const orderedIndexes = Object.fromEntries(
      order.map((val, index) => [val, index + 1])
    )

    return { orderedIndexes }
  }

  sortByIndex(a: Attribute, b: Attribute): number {
    const { orderedIndexes } = this.state

    // Items either have no sorting or it is just one of them
    if (orderedIndexes[a] === orderedIndexes[b]) return 0
    if (!orderedIndexes[a]) return 1
    if (!orderedIndexes[b]) return -1

    // Both items have sorting order
    return orderedIndexes[a] > orderedIndexes[b] ? 1 : -1
  }

  sortChildren(filters: ReactElement[]) {
    filters.sort((child1, child2) =>
      this.sortByIndex(
        child1.props.attribute || child1.props['data-attribute'],
        child2.props.attribute || child2.props['data-attribute']
      )
    )
  }

  render(): ReactNode {
    const { children } = this.props
    const filters = Children.toArray(children) as ReactElement[]

    this.sortChildren(filters)

    return filters
  }
}

type Attribute = string | number

type ComponentProps = {
  children: ReactElement[]
  order: Attribute[]
}

type ComponentState = {
  orderedIndexes: Record<Attribute, number>
}

export default DynamicFilters
